import { Controller } from "@hotwired/stimulus"
import 'lite-youtube-embed'

// Connects to data-controller="youtube"
export default class extends Controller {
  connect() {
    let el = document.createElement('lite-youtube')
    el.setAttribute('videoid', 'NSwNT3yXOcU')
    el.setAttribute('js-api', '1')
    el.setAttribute('params', 'enablejsapi=1&autoplay=0&mute=1&rel=0&controls=0&wmode=transparent&loop=1&vq=720')
    this.element.appendChild(el)

    setTimeout(() => {
      this.player();
    }, 500);
  }

  async player() {
    const player = await document.querySelector('lite-youtube').getYTPlayer();

    player.addEventListener('onStateChange', (event) => {
      console.log(event.data);
    });
  }
}
